import { render, staticRenderFns } from "./gj-breadcrumb.vue?vue&type=template&id=d3b8ff56&scoped=true&"
import script from "./gj-breadcrumb.vue?vue&type=script&lang=js&"
export * from "./gj-breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./gj-breadcrumb.vue?vue&type=style&index=0&id=d3b8ff56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b8ff56",
  null
  
)

export default component.exports